/**
 * Test data for the csv example file, which you can download.
 */
export class ImportCsvSample {
  public data: Array<Array<string>> = [
    [
      'Name prefix',
      'First name',
      'Middle name',
      'Last name',
      'Name suffix',
      'Gender',
      'Description',
      'Job Title',
      'Fax',
      'Skype',
      'Twitter',
      'Facebook',
      'Google+',
      'LinkedIn',
      'Birthday',
      'Source Name',
      'Contact Method Name',
      'Owner Username',
      'Assigned to Username',
      'Emails 1 Email',
      'Emails 2 Email',
      'Phones 1 Phone',
      'Groups 1 Label',
      'Accounts 1 Account name',
      'Accounts Default Contact 1 Account name',
      'Addresses 1 Label',
      'Addresses 1 Organization',
      'Addresses 1 Name prefix',
      'Addresses 1 First name',
      'Addresses 1 Middle name',
      'Addresses 1 Last name',
      'Addresses 1 Name suffix',
      'Addresses 1 Street',
      'Addresses 1 Street 2',
      'Addresses 1 Zip/Postal Code',
      'Addresses 1 City',
      'Addresses 1 State',
      'Addresses 1 State Combined code',
      'Addresses 1 Country ISO2 code',
      'oro.contact.bank_details.label',
      'oro.contact.company.label',
      'oro.contact.customer_number.label',
      'oro.contact.customer_pool.label',
      'oro.contact.membership_number.label',
      'oro.contact.membership_status.label',
      'Organization Name',
      'Picture',
      'Tags'
    ],
    [
      'Mr.',
      'Joe',
      'Junior',
      'Murphy',
      'PhD',
      'male',
      'I am working as a call agent',
      'Call agent',
      '999-111-232',
      '@skype',
      '@twitter',
      '@facebook',
      '@googleplus',
      '@linkedin',
      '03/07/1980',
      'other',
      '',
      'matthias.wiggins_5c086',
      'matthias.wiggins_5c086',
      'call@agent.com',
      'secondary@callagent.com',
      '585-255-1128',
      'Segmentation by benefits',
      'Life Plan Counselling',
      'Life Plan Counselling',
      'Primary Address',
      'b',
      'c',
      'Joe',
      'd',
      'Murphy',
      'e',
      '1215 Caldwell Road',
      'f',
      '14608',
      'Rochester',
      'g',
      'US-NY',
      'US',
      'SI56 9911 2231 0991',
      'Oro company',
      '123456789',
      '1',
      '123456',
      'alive',
      'OroCRM',
      'h',
      '#discontinued'
    ],
    [
      'Ms.',
      'Alice',
      'Junior',
      'Cooper',
      'PhD',
      'male',
      'I am working as a call agent',
      'Call agent',
      '999-111-232',
      '@skype',
      '@twitter',
      '@facebook',
      '@googleplus',
      '@linkedin',
      '01/02/1991',
      'other',
      '',
      'matthias.wiggins_5c086',
      'matthias.wiggins_5c086',
      'call@agent.com',
      'secondary@callagent.com',
      '585-255-1128',
      'Segmentation by benefits',
      'Life Plan Counselling',
      'Life Plan Counselling',
      'Primary Address',
      'b',
      'c',
      'Joe',
      'd',
      'Murphy',
      'e',
      '1215 Caldwell Road',
      'f',
      '14608',
      'Rochester',
      'g',
      'US-NY',
      'US',
      'SI56 9911 2231 0991',
      'Oro company',
      '123456789',
      '1',
      '123456',
      'alive',
      'OroCRM',
      'h',
      '#discontinued'
    ]
  ];
}
